import { createAction } from "@reduxjs/toolkit";
import { DeepPartial } from "redux";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { LaunchConfigurationsDTO } from "../launch-configurations/models/dto";
import { LaunchesDTO } from "./models/dto";

export namespace LaunchesActions {
  export enum ActionTypes {
    getLaunches = "Launches: Get All",
    setLaunches = "Launches: Set All",
    resetLaunches = "Launches: Reset All",
    getSingleLaunch = "Launches: Get Single",
    setSingleLaunch = "Launches: Set Single",

    setParticipationForm = "Launches: Set Participation Form",
  }

  // Actions Types
  export const getLaunches = createAction(ActionTypes.getLaunches);
  export const resetLaunches = createAction(ActionTypes.resetLaunches);

  export const setLaunches = createAction<
    FetchableSuccess<LaunchesDTO.Responses.GetAll.T> | FetchableError,
    ActionTypes.setLaunches
  >(ActionTypes.setLaunches);

  export const getSingleLaunch = createAction<
    LaunchesDTO.Responses.GetSingle.T["id"],
    ActionTypes.getSingleLaunch
  >(ActionTypes.getSingleLaunch);

  export const setSingleLaunch = createAction<
    { id: string; result: LaunchesDTO.Responses.GetSingle.T },
    ActionTypes.setSingleLaunch
  >(ActionTypes.setSingleLaunch);

  export const setParticipationForm = createAction<
    {
      id: LaunchConfigurationsDTO.Responses.GetSingle.T["id"];
      data: DeepPartial<LaunchesDTO.Requests.ParticipationForm.ForForm>;
    },
    ActionTypes.setParticipationForm
  >(ActionTypes.setParticipationForm);

  export type GetLaunches = ReturnType<typeof getLaunches>;
  export type ResetLaunches = ReturnType<typeof resetLaunches>;
  export type SetLaunches = ReturnType<typeof setLaunches>;
  export type SetSingleLaunch = ReturnType<typeof setSingleLaunch>;
  export type GetSingleLaunch = ReturnType<typeof getSingleLaunch>;
  export type SetParticipationForm = ReturnType<typeof setParticipationForm>;

  export type Actions =
    | GetLaunches
    | SetLaunches
    | ResetLaunches
    | SetSingleLaunch
    | GetSingleLaunch
    | SetParticipationForm;
}
